import { atom } from 'recoil';

/* 자동 팝업 기능 혹은 다른 위치의 팝업을 활성화가 필요한 팝업들 공통 상태 */

/**
 *  브랜드 팝업 활성화 상태
 *  */
export const brandSelectorState = atom<boolean>({
  key: 'brandSelector',
  default: false,
});

/**
 *  모델 팝업 활성화 상태
 *  */
export const modelSelectorState = atom<boolean>({
  key: 'modelSelector',
  default: false,
});

/**
 *  라인업 팝업 활성화 상태
 *  */
export const lineupSelectorState = atom<boolean>({
  key: 'lineupSelector',
  default: false,
});

/**
 *  트림 팝업 활성화 상태
 *  */
export const trimSelectorState = atom<boolean>({
  key: 'trimSelector',
  default: false,
});

/**
 *  외장 팝업 활성화 상태
 *  */
export const outsideColorSelectorState = atom<boolean>({
  key: 'outsideColorSelector',
  default: false,
});

/**
 *  내장 팝업 활성화 상태
 *  */
export const insideColorSelectorState = atom<boolean>({
  key: 'insideColorSelector',
  default: false,
});

/**
 *  내장재 팝업 활성화 상태
 *  */
export const interiorTextureSelectorState = atom<boolean>({
  key: 'interiorTextureSelector',
  default: false,
});

/**
 *  선택가격 팝업 활성화 상태
 *  */
export const optionSelectorState = atom<boolean>({
  key: 'optionSelector',
  default: false,
});

/**
 *  판매조건 팝업 활성화 상태
 *  */
export const saleSelectorState = atom<boolean>({
  key: 'saleSelector',
  default: false,
});

/**
 *  타금융사 할부비교 팝업 활성화 상태
 *  */
export const otherBankSelectorState = atom<boolean>({
  key: 'otherBankSelector',
  default: false,
});

/**
 *  검은색 배경 활성화 상태
 *  */
export const sustainableBgState = atom<boolean>({
  key: 'sustainableBg',
  default: false,
});
